<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  pleloader: Boolean,
  cookiesOk: Function
})


const handleCookiesClick = async () => {
  const success = await props.cookiesOk()

  if (success) {
    window.location.href = '/privacy-policy'
  }
}
</script>


<template>
  <section>
    <!-- preloader -->
    <div class="preloader" v-if="pleloader == true">
      <img src="@/assets/img/logo.png" alt="logo" class="preloader_img">
    </div>
    <!-- Modal Cookes -->
    <div id="modalCookes" class="modalCookes">
      <div class="cookes-info">
        <a class="cookesbtn" @click="cookiesOk">X</a>
        <h4>Файли cookie та конфіденційність</h4>
        <p>Продовжуючи перегляд цього сайту,<br>Ви підтверджуєте, що погоджуєтеся на використання файлів cookie.</p>
        <a class="linkMoreCookes" @click="handleCookiesClick">Детальніше...</a>
      </div>
    </div>
    <!------------------->
  </section>
</template>


<style scoped>


  .modalCookes
  {
    font-family: HeliosExtC;
    position: fixed;
    bottom: 50px;
    left: 50px;
    background-color: transparent;
    height: 140px;
    width: 480px;
    border-radius: 25px;
    z-index: 3;
    border: 1px solid rgba(118,122,118,1);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    z-index:5;
  }

  .cookesbtn
  {
    height: 34px;
    padding: 0;
    border-radius: 999px;
    border: 1px solid rgba(118,122,118,1);
    background: transparent;
    color: #FFF;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 80px;
    position: absolute;
    top: -5px;
    right: 0px;
    cursor: pointer;
    font-size: 12px;
  }

  .cookes-info
  {
    margin: 26px 42px 26px 22px;
    position: relative;
  }
  .cookes-info h4
  {
    font-size: 12px;
    line-height: 120%;
  }

  .cookes-info p
  {
    font-size: 12px;
    line-height: 120%;
  }

  .linkMoreCookes
  {
    margin-top: 10px;
    display: block;
    font-size: 12px;
    color: #9D9C9C;
    width: 100%;
    cursor: pointer;
  }

  .modalCookesOff
  {
    display: none;
  }

  .preloader
  {
    position: fixed;
    height: 100%;
    width: 100%;
    background: #000;
    z-index: 1010;
  }

  .preloader_img
  {
    position: absolute;
    width: 208px;
    top: calc(50% - 20px);
    left: calc(50% - 104px);
  }
  /*media*/
  @media only screen and (min-width:0px) and (max-width:992px)
  {
    .modalCookes
    {
      position: fixed;
      bottom: 0px;
      left: 0px;
      height: 140px;
      width: 100%;
      z-index: 10;
    }
  }

  @media only screen and (min-width:992.99px) and (max-width:1080px)
  {


  }


</style>